import React from "react";
import PropTypes from "prop-types";
import { startCase } from "lodash";

export function ReminderStatusOptions({ options, value = "open" }) {
  const statuses = [...new Set(["open", ...options, value].filter(Boolean))];
  return statuses.map((status) => (
    <option key={status} value={status}>
      {status === "open" ? "open" : startCase(status)}
    </option>
  ));
}

ReminderStatusOptions.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string,
};
